import { createSlice } from '@reduxjs/toolkit';
import StkGirisDTO from 'src/models/StokEczane/GirisIslemleri/StkGirisDTO';
import StkGirisSearchDTO from 'src/models/StokEczane/GirisIslemleri/StkGirisSearchDTO';
import VwStkGirisDTO from 'src/models/StokEczane/GirisIslemleri/VwStkGirisDTO';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';
import { useAppSelector } from 'src/store';
import { helper } from 'src/utils/helper';

interface IStokGirisState {
  isSearchSubmit: boolean;
  stokGirisList: VwStkGirisDTO[];
  stokSearchState: boolean;
  activeStokGiris: StkGirisDTO;
  activeStokGirisId?: number;
  stokGirisMuracaatId?: number;
  refetch: boolean;
  aramaKriterleri:StkGirisSearchDTO;
}

const StokGirisSlice = createSlice<
  IStokGirisState,
  MapReducerPayloads<
    IStokGirisState,
    {
      setIsSearchSubmit: boolean;
      setStokGirisList: VwStkGirisDTO[];
      setStokSearchState: boolean;
      setActiveStokGiris: StkGirisDTO;
      setActiveStokGirisId: number;
      setActiveStokGirisMuracaatId: number;
      setStokGirisMuracaatId: number;
      setRefetch: boolean;
      setAramaKriterleri:StkGirisSearchDTO;
    }
  >
>({
  name: 'StokGiris',
  initialState: {
    isSearchSubmit: true,
    stokGirisList: null,
    stokSearchState: false,
    activeStokGiris: null,
    stokGirisMuracaatId: null,
    refetch: false,
    aramaKriterleri:{
        ...new StkGirisSearchDTO(),
        baslangicTarih: helper.beforeDays(new Date(),1),
        bitisTarih: new Date(),
      },
  },
  reducers: {
    setIsSearchSubmit: (state, action) => {
      state.isSearchSubmit = action.payload;
    },
    setStokGirisList: (state, action) => {
      state.stokGirisList = action.payload;
    },
    setStokSearchState: (state, action) => {
      state.stokSearchState = action.payload;
    },
    setActiveStokGiris: (state, action) => {
      state.activeStokGiris = action.payload;
    },
    setActiveStokGirisId: (state, action) => {
      state.activeStokGirisId = action.payload;
    },
    setActiveStokGirisMuracaatId: (state, action) => {
      if (state.activeStokGiris != null)
        state.activeStokGiris.hastamuracaatId = action.payload;
    },
    setStokGirisMuracaatId: (state, action) => {
      state.stokGirisMuracaatId = action.payload;
    },
    setRefetch: (state, action) => {
      state.refetch = action.payload
    },
    setAramaKriterleri: (state, action) => {
      state.aramaKriterleri = action.payload
    }
  }
});

export default StokGirisSlice;
